"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicComponent = void 0;
var constants_1 = require("../../constants");
var window_1 = require("../../utils/window");
var dom_1 = require("../../utils/dom");
var DynamicComponent = /** @class */ (function () {
    function DynamicComponent() {
        this.containerElement = '';
        this.elements = [];
        this.globalWindow = new window_1.WindowAdapter();
    }
    Object.defineProperty(DynamicComponent.prototype, "getContainerElement", {
        get: function () {
            return dom_1.atDocument().getElementById(this.containerElement);
        },
        enumerable: false,
        configurable: true
    });
    DynamicComponent.prototype.createWorkSpace = function (id) {
        if (id === void 0) { id = constants_1.CONTAINER_WA; }
        this.containerElement = id;
        var dc = dom_1.atDocument();
        var container = dc.createElement('div');
        container.setAttribute('id', id);
        dc.body.appendChild(container);
    };
    DynamicComponent.prototype.props = function (key, props) {
        if (key === void 0) { key = ''; }
        this.globalWindow.setProps("" + key, props);
    };
    DynamicComponent.prototype.render = function (selector, attributes) {
        var el = dom_1.atDocument().createElement(selector);
        el.setAttribute('id', "parent-" + selector + "-" + this.elements.length);
        Object.keys(attributes).forEach(function (value, index) { return el.setAttribute(value, attributes[value]); });
        this.getContainerElement.appendChild(el);
        this.elements.push(el);
        this.globalWindow.setWebComponent(el);
    };
    DynamicComponent.prototype.fragmentRender = function (selector) {
        var fragment = new DocumentFragment();
        var el = dom_1.atDocument().createElement(selector);
        el.setAttribute('id', "parent-" + selector);
        fragment.appendChild(el);
        this.getContainerElement.appendChild(fragment);
    };
    DynamicComponent.prototype.input = function (selector, props) {
        var elements = dom_1.atDocument().getElementsByTagName(selector);
        var components = Object.values(elements);
        components.forEach(function (el) { return props.
            forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return el.setAttribute(name, value);
        }); });
    };
    return DynamicComponent;
}());
exports.DynamicComponent = DynamicComponent;
